import type { PropsWithChildren } from 'react';
import { styled } from '@/styled-system/jsx';

const AvatarContainer = styled('div', {
  base: {
    position: 'relative',
  },
});

const AvatarCircle = styled('div', {
  base: {
    position: 'absolute',
    top: 0,
    left: 0,
    borderRadius: '50%',
    backgroundColor: 'brand',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    overflow: 'visible',
    boxSizing: 'content-box',
  },
  variants: {
    withBorder: {
      true: {
        border: '2px solid white',
      },
      false: {},
    },
  },
});

const InstagramOutline = styled('div', {
  base: {
    position: 'absolute',
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    margin: '-2px',
    borderRadius: '50%',
    background: 'linear-gradient(to right, #c913b9, #f9373f, #f9373f, #fecd00)',
  },
});

export const ZillowAvatarImage = ({
  size,
  withInstagramBorder,
  children,
}: PropsWithChildren<{ size: number; withInstagramBorder?: boolean }>) => {
  const containerStyle = {
    width: `${withInstagramBorder ? size + 4 : size}px`,
    height: `${withInstagramBorder ? size + 4 : size}px`,
  };

  const circleStyle = {
    width: `${size}px`,
    height: `${size}px`,
  };

  return (
    <AvatarContainer style={containerStyle}>
      {withInstagramBorder && <InstagramOutline />}
      <AvatarCircle withBorder={withInstagramBorder} style={circleStyle}>
        {children}
      </AvatarCircle>
    </AvatarContainer>
  );
};
